/* eslint-disable @typescript-eslint/camelcase */
import DefaultSegmentAdapter, {
  PracticeSheetSegmentEvents,
} from '@fenderdigital/tablature/segment-adapters/practice-mode/DefaultSegmentAdapter';
import {
  SegmentLibWeb,
  SegmentAdapterType,
} from '@fenderdigital/tablature/segment-adapters/common';

export default class SegmentAdapter extends DefaultSegmentAdapter {
  segment: SegmentLibWeb;
  data: Record<any, unknown>;

  constructor(segment: SegmentLibWeb, data: Record<any, unknown>) {
    super(SegmentAdapterType.Web);
    this.segment = segment;
    this.data = data;
  }

  play(): void {
    this.segment.event(PracticeSheetSegmentEvents.PracticeSheetPlay, { title: this.title });
  }

  metronome(enabled: boolean): void {
    this.segment.event(PracticeSheetSegmentEvents.PracticeSheetMetronome, {
      title: this.title,
      status: enabled,
    });
  }

  launch(): void {
    this.segment.event(PracticeSheetSegmentEvents.PracticeSheetLaunch, {
      title: this.title,
    });
  }

  exit(): void {
    this.segment.event(PracticeSheetSegmentEvents.PracticeSheetExit, { title: this.title });
  }
}
